<template>
  <div class="imei-chip">
    <span class="imei-label">IMEI</span>
    <span class="imei-value">{{ imei }}</span>
    <button class="copy-btn" @click="copyImei" :title="'Copy ' + imei">
      <i class="fas fa-copy"></i>
    </button>
    <transition name="fade">
      <span v-if="copied" class="copied-msg">Đã copy!</span>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ImeiChip',
  props: {
    imei: { type: String, required: true },
  },
  data() {
    return { copied: false };
  },
  methods: {
    copyImei() {
      navigator.clipboard.writeText(this.imei);
      this.copied = true;
      setTimeout(() => (this.copied = false), 1500);
    },
  },
};
</script>

<style scoped>
.imei-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border: 1px solid #d0e2ff;
  border-radius: 5px;
  background: #f8faff;
  position: relative;
  font-size: 13px;
}

.imei-label {
  color: blue;
  font-weight: 600;
  font-size: 13px;
  padding: 2px 6px;
  border-radius: 6px;
  margin-right: 4px;
}
</style>
